import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61e896eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-column" }
const _hoisted_2 = {
  class: "text-primary-dark pb-3",
  "data-test-ref": "password-interrupt-title"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "password-interrupt-system-error-icon"
}, null, -1 /* HOISTED */))
const _hoisted_5 = {
  class: "mb-0",
  "data-test-ref": "password-interrupt-system-error-text"
}
const _hoisted_6 = {
  class: "text-primary-dark",
  "data-test-ref": "password-interrupt-new-password-label"
}
const _hoisted_7 = { class: "d-flex flex-wrap" }
const _hoisted_8 = { class: "flex-grow-1 min-w-0" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "position-relative d-inline-block w-100" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_13 = {
  key: 2,
  class: "text-success"
}
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "position-relative d-inline-block w-100" }
const _hoisted_16 = { class: "flex-grow-1 mt-4 min-w-0" }
const _hoisted_17 = { class: "d-flex flex-column pl-4" }
const _hoisted_18 = {
  class: "pl-3",
  "data-test-ref": "password-requirements-title"
}
const _hoisted_19 = { "data-test-ref": "requirement-number" }
const _hoisted_20 = { class: "icon-placeholder" }
const _hoisted_21 = { "data-test-ref": "requirement-length" }
const _hoisted_22 = { class: "icon-placeholder" }
const _hoisted_23 = { "data-test-ref": "requirement-different" }
const _hoisted_24 = { class: "icon-placeholder" }
const _hoisted_25 = { class: "icon-placeholder" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-top my-3" }, null, -1 /* HOISTED */))
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-white fas fa-chevron-right",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_29 = { "data-test-ref": "password-interrupt-interrupt-text" }

import { reactive, ref, computed, watch, onMounted } from 'vue';
import { useI18n } from '@/i18n';
import { useVuelidate } from '@vuelidate/core';
import { AxiosError } from 'axios';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { createPasswordHelpService } from '@/composables/password-help';
import PasswordInterruptModal from './password-interrupt-modal.vue';
import { useAppStore } from '@/store';
import { useSiteConfig } from '@/composables/site-config';
import { passwordRules } from 'commercial-web-client-utilities/dist/member';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { useLoginForm } from '@/composables/login-form';


export default /*#__PURE__*/_defineComponent({
  __name: 'password-interrupt',
  props: {
    aemSiteIdentifier: { type: String, default: '' },
},
  setup(__props) {

const props = __props;

const nonSecureService = useNonsecureService();
const ledsService = useLedsService();
const siteConfig = useSiteConfig();
const passwordHelpService = createPasswordHelpService({
    nonSecureService: nonSecureService,
    ledsService: ledsService
});
const appStore = useAppStore();
const { t } = useI18n();
const updatePasswordFormData = reactive({
    password: '',
    confirmPassword: ''
});
const userName = ref<string>('');
const isSystemError = ref<boolean>(false);
const loading = ref<boolean>(false);
const showPassword = ref<boolean>(false);
const showConfirmPassword = ref<boolean>(false);
const submitted = ref<boolean>(false);
const hasTyped = ref<boolean>(false);
const showFaqModal = ref<boolean>(false);
const blurred = reactive({
    password: false,
    confirmPassword: false
});
const updatePasswordToken = sessionStorage.getItem('updatePasswordToken') ?? '';
const rules = computed(() => passwordRules(userName, updatePasswordFormData));
const v$ = useVuelidate(rules, updatePasswordFormData, { $lazy: true, $autoDirty: true });

const hasAnySpecialChar = computed(() => /[^a-zA-Z0-9\s]/.test(updatePasswordFormData.password));
const hasSpecialChar = computed(() => /[~!@#%^&$()_{}|.?]/.test(updatePasswordFormData.password));

// eslint-disable-next-line no-undef

const {
    username,
    password,
    login,
} = useLoginForm({ aemSiteIdentifier: props.aemSiteIdentifier });

const passwordStrength = computed(() => {
    const password = updatePasswordFormData.password || '';
    if (!password || !v$.value?.password) return '';
    const validators = v$.value.password;
    if (!validators.minLength.$invalid && !validators.maxLength.$invalid) {
        let strength = 1;
        if (validators.noDisallowedSpecialChar.$invalid) return 'Weak';
        if (!validators.hasNumber.$invalid && !validators.differentFromUsername.$invalid) {
            strength = 2;
            if (hasSpecialChar.value) {
                strength = 3;
            }
        }
        return strength;
    }
    return '';
});

const isPasswordMeetsRequirements = computed(() => {
    if (!v$.value?.password) return false;
    const validators = v$.value.password;
    return (
        !validators.minLength.$invalid
        && !validators.maxLength.$invalid
        && !validators.hasNumber.$invalid
        && !validators.noDisallowedSpecialChar.$invalid
        && !validators.differentFromUsername.$invalid
    );
});

watch(() => updatePasswordFormData.password, (newValue) => {
    blurred.password = false;
    if (!newValue) hasTyped.value = false;
});

watch(() => updatePasswordFormData.confirmPassword, () => {
    blurred.confirmPassword = false;
});

/*---------*\
| Lifecycle |
\*---------*/

onMounted(async () => {
    loading.value = true;
    try {
        const updatePasswordResponse = await passwordHelpService.getUsernameForpasswordInterrupt({
            signal: new AbortController().signal,
            updatePasswordToken
        });
        userName.value = updatePasswordResponse.data.username ?? '';
    } catch (error) {
        logger.error(error, 'error in username');
    } finally {
        loading.value = false;
    }
});

const handleSubmit = async () => {
    submitted.value = true;
    v$.value.$touch();
    blurred.password = true;
    blurred.confirmPassword = true;
    if (v$.value.$invalid) {
        logger.log('Password validation failed');
        return;
    }
    try {
        loading.value = true;
        const updatePasswordResponse = await passwordHelpService.passwordInterrupt({
            payload: {
                newPassword: updatePasswordFormData.password
            },
            updatePasswordToken,
            signal: new AbortController().signal
        });
        logger.log('Password updated.', updatePasswordResponse.data);
    } catch (axiosError) {
        const errorCode = (axiosError as AxiosError)?.response?.status;
        isSystemError.value = true;
        logger.error('Failed to update password', errorCode);
    } finally {
        loading.value = false;
    }

    try {
        loading.value = true;
        username.value = userName.value;
        password.value = updatePasswordFormData.confirmPassword;
        await login();
    } catch (axiosError) {
        navigateToLogin();
    } finally {
        loading.value = false;
    }
};

const handleCancel = () => {
    showFaqModal.value = true;
};

const leavePage = () => {
    showFaqModal.value = false;
    navigateToLogin();
};

const stayOnPage = () => {
    showFaqModal.value = false;
};

const navigateToLogin = () => {
    logger.log(appStore.logoutUrl, 'appStore.logoutUrl');
    window.location.href = appStore.logoutUrl;
};

return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_text = _resolveComponent("b-form-text")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _component_b_container = _resolveComponent("b-container")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_b_overlay, {
        show: loading.value,
        variant: "light",
        opacity: "0.75",
        rounded: "sm",
        "data-test-ref": "password-interrupt-overlay"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("h1", _hoisted_2, null, 512 /* NEED_PATCH */), [
              [_directive_t, 'passwordHelp.title.passwordInterrupt']
            ]),
            _createElementVNode("p", {
              class: "text-muted",
              "data-test-ref": "multi-factor-auth-code-receive-info",
              innerHTML: _unref(t)('passwordHelp.passwordInterrupt.info')
            }, null, 8 /* PROPS */, _hoisted_3),
            (isSystemError.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 0,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "password-interrupt-system-error-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('passwordHelp.error.passwordInterruptSystemError')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _withDirectives(_createElementVNode("h2", _hoisted_6, null, 512 /* NEED_PATCH */), [
              [_directive_t, 'passwordHelp.label.passwordInterrupt']
            ]),
            _createVNode(_component_b_form, {
              "data-test-ref": "password-interrupt-form",
              novalidate: "",
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_b_form_group, {
                      "label-for": "new-password",
                      class: "mb-4",
                      "data-test-ref": "password-interrupt-new-password-group"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('passwordHelp.label.password')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_b_form_input, {
                            id: "new-password",
                            modelValue: updatePasswordFormData.password,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updatePasswordFormData.password) = $event)),
                            type: showPassword.value ? 'text' : 'password',
                            autocomplete: "off",
                            maxlength: "25",
                            class: _normalizeClass(["has-visibility-toggle", {
                                            'is-invalid': (blurred.password || submitted.value) &&
                                                (!updatePasswordFormData.password || !_unref(isPasswordMeetsRequirements)
                                                    || _unref(passwordStrength) === ''),
                                            'is-valid': (blurred.password || submitted.value) &&
                                                _unref(isPasswordMeetsRequirements) &&
                                                updatePasswordFormData.password &&
                                                _unref(passwordStrength) === 3,
                                            'hide-icon': updatePasswordFormData.password !== ''
                                        }]),
                            "aria-invalid": (blurred.password || submitted.value)
                                            && !updatePasswordFormData.password,
                            "aria-describedby": "password-strength-error password-empty-error",
                            "data-test-ref": "new-password-input",
                            onBlur: _cache[1] || (_cache[1] = ($event: any) => (blurred.password = true)),
                            onInput: _cache[2] || (_cache[2] = ($event: any) => (hasTyped.value = true))
                          }, null, 8 /* PROPS */, ["modelValue", "type", "class", "aria-invalid"]),
                          _createVNode(_component_b_button, {
                            type: "button",
                            class: _normalizeClass(["visibility-toggle", {
                                            'active': showPassword.value,
                                            'invalid-shift': (blurred.password || submitted.value)
                                                && !updatePasswordFormData.password
                                        }]),
                            style: _normalizeStyle([{"position":"absolute","top":"50%","transform":"translateY(-50%)"}, { 'right': (blurred.password || submitted.value)
                                            && !updatePasswordFormData.password ? '2.5rem' : '0.75rem' }]),
                            "aria-label": "Toggle password visibility",
                            "data-test-ref": "new-password-visibility-toggle",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(showPassword.value ?
                                                'fas fa-eye-slash' : 'fas fa-eye')
                              }, null, 2 /* CLASS */)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "style"])
                        ]),
                        _createVNode(_component_b_form_text, {
                          id: "password-strength-error",
                          "data-test-ref": "password-strength-text"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                                            'text-danger': (blurred.password || submitted.value)
                                                && !updatePasswordFormData.password
                                        }),
                              "data-test-ref": "password-interrupt-password-strength"
                            }, [
                              _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.label.passwordStrength')) + " ", 1 /* TEXT */),
                              (_unref(passwordStrength) === 1)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(_unref(t)('passwordHelp.strength.weak')), 1 /* TEXT */))
                                : (_unref(passwordStrength) === 2)
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_12, _toDisplayString(_unref(t)('passwordHelp.strength.moderate')), 1 /* TEXT */))
                                  : (_unref(passwordStrength) === 3)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString(_unref(t)('passwordHelp.strength.strong')), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ], undefined, true),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_b_form_group, {
                      "label-for": "confirm-password",
                      "data-test-ref": "password-interrupt-confirm-password-group"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('passwordHelp.label.confirmPassword')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_b_form_input, {
                            id: "confirm-password",
                            modelValue: updatePasswordFormData.confirmPassword,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updatePasswordFormData.confirmPassword) = $event)),
                            type: showConfirmPassword.value ? 'text' : 'password',
                            autocomplete: "off",
                            maxlength: "25",
                            class: _normalizeClass(["has-visibility-toggle", {
                                            'is-invalid':
                                                (blurred.confirmPassword || submitted.value)
                                                && (!updatePasswordFormData.confirmPassword
                                                    || _unref(v$).confirmPassword?.passwordsMatch?.$invalid),
                                            'is-valid': (blurred.confirmPassword || submitted.value)
                                                && (updatePasswordFormData.confirmPassword
                                                    || !_unref(v$).confirmPassword?.passwordsMatch?.$invalid),
                                            'hide-icon': updatePasswordFormData.confirmPassword !== ''
                                                && !blurred.confirmPassword
                                        }]),
                            "aria-invalid": (blurred.confirmPassword || submitted.value) &&
                                            (!updatePasswordFormData.confirmPassword
                                                || _unref(v$).confirmPassword?.passwordsMatch?.$invalid),
                            "aria-describedby": "passwords-match-error confirm-password-empty-error",
                            "data-test-ref": "confirm-password-input",
                            onInput: _cache[5] || (_cache[5] = ($event: any) => {hasTyped.value = true;}),
                            onBlur: _cache[6] || (_cache[6] = ($event: any) => (blurred.confirmPassword = true)),
                            onPaste: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                          }, null, 8 /* PROPS */, ["modelValue", "type", "class", "aria-invalid"]),
                          _createVNode(_component_b_button, {
                            type: "button",
                            class: _normalizeClass(["visibility-toggle", {
                                            'active': showConfirmPassword.value,
                                            'invalid-shift': (blurred.confirmPassword || submitted.value) &&
                                                !updatePasswordFormData.confirmPassword,
                                        }]),
                            style: _normalizeStyle([{"position":"absolute","top":"50%","transform":"translateY(-50%)"}, { 'right': (blurred.confirmPassword || submitted.value) &&
                                            !updatePasswordFormData.confirmPassword ? '2.5rem' : '0.75rem' }]),
                            "aria-label": "Toggle confirm password visibility",
                            "data-test-ref": "confirm-password-visibility-toggle",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(showConfirmPassword.value ?
                                                'fas fa-eye-slash' : 'fas fa-eye')
                              }, null, 2 /* CLASS */)
                            ], undefined, true),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["class", "style"])
                        ]),
                        (updatePasswordFormData.password && updatePasswordFormData.confirmPassword)
                          ? (_openBlock(), _createBlock(_component_b_form_text, {
                              key: 0,
                              id: "passwords-match-error",
                              "data-test-ref": "password-interrupt-passwords-match"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass({
                                            'text-success': !_unref(v$).confirmPassword?.passwordsMatch?.$invalid,
                                            'text-danger': _unref(v$).confirmPassword?.passwordsMatch?.$invalid
                                        })
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(!_unref(v$).confirmPassword?.passwordsMatch?.$invalid
                                                ? 'fas fa-check' : 'fas fa-times')
                                  }, null, 2 /* CLASS */),
                                  _createTextVNode(" " + _toDisplayString(!_unref(v$).confirmPassword?.passwordsMatch?.$invalid
                                            ? _unref(t)('passwordHelp.passwordsMatch')
                                            : _unref(t)('passwordHelp.passwordsMismatch')), 1 /* TEXT */)
                                ], 2 /* CLASS */)
                              ], undefined, true),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ], undefined, true),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("strong", _hoisted_18, _toDisplayString(_unref(t)('passwordHelp.title.passwordRequirements')), 1 /* TEXT */),
                      _createElementVNode("ul", {
                        class: "requirements-list",
                        style: _normalizeStyle({ 'list-style-type': !updatePasswordFormData.password
                                        || !hasTyped.value ? 'circle' : 'none' }),
                        "data-test-ref": "password-interrupt-requirements-list"
                      }, [
                        _createElementVNode("li", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, [
                            (updatePasswordFormData.password && hasTyped.value
                                                    && _unref(v$).password?.hasNumber)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(!_unref(v$).password.hasNumber.$invalid ?
                                                    'fas fa-check text-success' : 'fas fa-times text-danger')
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('passwordHelp.requirements.atLeastOneNumber')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("li", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            (updatePasswordFormData.password && hasTyped.value
                                                    && _unref(v$).password?.minLength
                                                    && _unref(v$).password?.maxLength)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass((!_unref(v$).password.minLength.$invalid &&
                                                    !_unref(v$).password.maxLength.$invalid) ?
                                                    'fas fa-check text-success' : 'fas fa-times text-danger')
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('passwordHelp.requirements.length')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("li", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, [
                            (updatePasswordFormData.password && hasTyped.value
                                                    && _unref(v$).password?.differentFromUsername)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(!_unref(v$).password.differentFromUsername.$invalid ?
                                                    'fas fa-check text-success' : 'fas fa-times text-danger')
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('passwordHelp.requirements.notUsername')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("li", {
                          style: _normalizeStyle({
                                            'list-style-type':
                                                (!updatePasswordFormData.password || !hasTyped.value || !_unref(hasAnySpecialChar)) ?
                                                    'circle' : 'none',
                                            'white-space': 'pre-wrap'
                                        }),
                          "data-test-ref": "requirement-special-chars"
                        }, [
                          _createElementVNode("span", _hoisted_25, [
                            (updatePasswordFormData.password && hasTyped.value)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass({
                                                    'fas fa-times text-danger':
                                                        _unref(v$).password.noDisallowedSpecialChar.$invalid,
                                                    'fas fa-check text-success': _unref(hasSpecialChar)
                                                })
                                }, null, 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('passwordHelp.requirements.specialCharacters')), 1 /* TEXT */)
                        ], 4 /* STYLE */)
                      ], 4 /* STYLE */)
                    ])
                  ])
                ]),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_b_link, {
                    "data-test-ref": "password-interrupt-cancel-button",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.action.cancel')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_b_button, {
                    variant: "primary",
                    type: "submit",
                    "data-test-ref": "password-interrupt-submit-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.action.updatePassword')) + " ", 1 /* TEXT */),
                      _hoisted_28
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onSubmit"]),
            _createElementVNode("p", _hoisted_29, [
              _createVNode(_component_i18n_t, {
                keypath: "passwordHelp.help.furtherAssistance",
                scope: "global"
              }, {
                technicalSupport: _withCtx(() => [
                  _createVNode(_component_b_link, {
                    "data-test-ref": "password-interrupt-technical-support-link",
                    onClick: _unref(siteConfig).redirectToTechSupport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.link.technicalSupport')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                callSupport: _withCtx(() => [
                  _createVNode(_component_b_link, { "data-test-ref": "password-interrupt-call-support-link" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('passwordHelp.link.technicalSupportNumber')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _createVNode(PasswordInterruptModal, {
        id: "navigationInterruptModal",
        modelValue: showFaqModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showFaqModal).value = $event)),
        onLeavePage: leavePage,
        onStayOnPage: stayOnPage
      }, null, 8 /* PROPS */, ["modelValue"])
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}
}

})